import { render, staticRenderFns } from "./HomeActivity.vue?vue&type=template&id=74884300&scoped=true"
import script from "./HomeActivity.vue?vue&type=script&lang=js"
export * from "./HomeActivity.vue?vue&type=script&lang=js"
import style0 from "./HomeActivity.vue?vue&type=style&index=0&id=74884300&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74884300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74884300')) {
      api.createRecord('74884300', component.options)
    } else {
      api.reload('74884300', component.options)
    }
    module.hot.accept("./HomeActivity.vue?vue&type=template&id=74884300&scoped=true", function () {
      api.rerender('74884300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/HomeActivity.vue"
export default component.exports